<template>
  <div class="salesCommission">
    <div class="content">
      <div class="panel"
        v-loading.fullscreen="loading"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 0.5)"
      >
        <mtable v-if="trData"
          :thData="thData"
          :trData="trData"
          :multiLanguage="multiLanguage"
          :selPage="selPage"
          :seekDropdown="seekDropdown"
          :page="page"
          :jsonExcelAjax="jsonExcelAjax"
          :handle="handle"
          :sort="sort"
          :isSetting="isSetting"
          :region='curArea'
          :label='label'
          @seek="tableAjax"
          @tableChange="tableAjax">
        </mtable>
      </div>
    </div>
  </div>
</template>

<script>
  import mtable from "./sTable"
  import { Api } from 'api/commissionEnv'
  import { URL_SALELIST } from 'api/commissionApi'
  import { getTimeDiff } from 'common/js/util'

  var api = new Api()
export default {
  name: 'salesCommission',
  props: ['curArea','status'],
  mixins: [
    require("common/mixin/base.js").base({multiLanguage:"commissionTable"})
  ],
  components: {
      mtable,
  },
  data () {
      return {
        UTCDIFF: getTimeDiff(),
        loading: false,
        label: 'getSalesInfo',
        region: 'GM',
        isSetting: {
          list: {  // 状态列表
            allStatus: "allStatus",
            sated: "sated",
            unsated: "unsated",
            checked: 'checked',
            unchecked: 'unchecked',
          },
          active: this.status ? this.status : null,
          listActive: this.status && this.status == '0' ? 'unsated' : this.status && this.status == '1' ? 'unchecked' : 'allStatus',
        },
        trData: "", //  表格tr数据
        sort: {  // 排序
          key: "sales_id",
          method: "ASC"
        },
        handle: {  //  操作
          link: "saleCommissionSetting",
          idKey: "sales_id",
          delete: false
        },
        seekDropdown: {  // 搜索选项
          list: {  // 搜索项列表
            loginId: "sales_id",
            userName: "acc_name",
            phone: "phone",
            email: "email"
          },
          active: 'loginId', // list坐标
          seekStr: ""  // 搜索内容
        },
        page: {  // 分页
          active: 1,
          pageLeng: 0,
          offset: 0  // 查询数据库的offset需要的值，初始只为0组件内部处理最后给出一个能直接传给后台的值
        },
        selPage: {  // 配合分页的显示col数目选择
          list: [5, 10, 25, 50],  // 选择显示col数目
          active: localStorage.pageMaxIndex,  // 当前list的坐标
          limit: [5, 10, 25, 50][localStorage.pageMaxIndex]  // 查询数据库的limit需要的值，初始值设为list的0坐标组件内部处理最后给出一个传给后台的值
        }
      }
    },
    mounted () {
      this.seekDropdown && (this.seekDropdown.seekStr = "")
      this.tableAjax()
    },
    computed: {
      thData() {  // 表格th数据
        return [this.multiLanguage.th.loginId,this.multiLanguage.th.accountName,this.multiLanguage.th.phone,this.multiLanguage.th.email,this.multiLanguage.th.remark,this.multiLanguage.th.officeState.name,this.multiLanguage.th.last_update,this.multiLanguage.th.settingStatus,]
      },
      jsonExcelAjax () {
        return {
          url: api.getUrl20(this.curArea,URL_SALELIST),
          ajaxType: "get",
          getKey: ["data", "data", "sales_info"],
          ajaxPar: {
            limit: this.$ALLNUM,
            offset: 0,
            sort: this.sort.method,
            sortKey: this.sort.key,
            seekKey: this.seekDropdown.list[this.seekDropdown.active],
            seekVal: this.seekDropdown.seekStr,
            isSetting: this.isSetting.active,

          }
        }
      }
    },
    methods: {
       tableAjax() {
        try {
          this.loading = true
          let offset = this.page.offset
          let limit = this.selPage.limit
          let sortKey = this.sort.key
          let sort = this.sort.method
          let seekKey = this.seekDropdown.list[this.seekDropdown.active]
          let seekVal = this.seekDropdown.seekStr
          let isSetting = this.isSetting.active
          this.$http(api.getUrl20(this.curArea,URL_SALELIST),{
          params: {limit, offset, sortKey, sort, seekKey, seekVal, isSetting},
          headers: {
            UTCDIFF: this.UTCDIFF
          }
          }).then((res) => {
            let data = res.data.data
            this.trData = data.sales_info
            this.page.pageLeng = data.pageLength
            this.loading = false
          })
        } catch (error) {
          this.loading = false
        }

      },
      setOfficeState() {
        if (Object.prototype.toString.call(this.trData) == "[object Array]") {
          this.trData.forEach((item,index) => {
            this.trData[index].officeState =
            ( this.trData[index].officeState == "F"?this.multiLanguage.th.officeState.countryArr[0].text:
              this.trData[index].officeState == "P"?this.multiLanguage.th.officeState.countryArr[1].text:
              this.multiLanguage.th.officeState.countryArr[2].text
            )
            this.trData[index].status = this.trData[index].status == true? this.multiLanguage.isSetting.sated:this.multiLanguage.isSetting.unsated
          })
        }
      }
    },
    watch: {
      curArea () { // 监听：curArea 地区发生变化时，根据地区不同，初始化的baseUrl，之后执行tableAjax方法
        this.tableAjax()
      },
      multiLanguage() {
        // this.setOfficeState()
      }
    }
}
</script>




// WEBPACK FOOTER //
// saleSettingView.vue?74a9c2e2